import Logo from "@components/ui/logo";
import { SidebarHeader } from "@components/ui/sidebar";

export function HeaderNav() {
  return (
    <SidebarHeader>
      <div className="flex items-center justify-between">
        <Logo className="w-fit" />
      </div>
    </SidebarHeader>
  );
}
